import { SVGProps } from "react";

export const EyeVisible = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.534 4.69063C12.0527 1.57031 9.81366 0 6.8121 0C3.80898 0 1.57148 1.57031 0.090227 4.69219C0.0308135 4.818 0 4.9554 0 5.09453C0 5.23366 0.0308135 5.37107 0.090227 5.49687C1.57148 8.61719 3.81054 10.1875 6.8121 10.1875C9.81523 10.1875 12.0527 8.61719 13.534 5.49531C13.6543 5.24219 13.6543 4.94844 13.534 4.69063ZM6.8121 9.0625C4.29179 9.0625 2.44648 7.78438 1.14491 5.09375C2.44648 2.40313 4.29179 1.125 6.8121 1.125C9.33241 1.125 11.1777 2.40313 12.4793 5.09375C11.1793 7.78438 9.33398 9.0625 6.8121 9.0625ZM6.7496 2.34375C5.23085 2.34375 3.9996 3.575 3.9996 5.09375C3.9996 6.6125 5.23085 7.84375 6.7496 7.84375C8.26835 7.84375 9.4996 6.6125 9.4996 5.09375C9.4996 3.575 8.26835 2.34375 6.7496 2.34375ZM6.7496 6.84375C5.78241 6.84375 4.9996 6.06094 4.9996 5.09375C4.9996 4.12656 5.78241 3.34375 6.7496 3.34375C7.71679 3.34375 8.4996 4.12656 8.4996 5.09375C8.4996 6.06094 7.71679 6.84375 6.7496 6.84375Z"
      fill="black"
      fillOpacity="0.45"
    />
  </svg>
);
